
import { papers } from "../endpoints";
import { Items } from "./Items";
import { makeObservable, computed } from "mobx";

export class Papers extends Items {
    constructor() {
        super();
        this.getItems = papers.getPapers;
        makeObservable(this, {
            papers: computed,
        })
    }

    get papers() {
        return Array.isArray(this.items) ? this.items : [];
    }



}